module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/Welcomeback-75f47f028ef1ee52ad8d795b1ac3e4d5.png";